module.exports = __webpack_public_path__ + "img/logo2.f15e80e6.png";